<!-- 签名处理 -->
<template>
    <div class="esignHandle">
        <div>
            <el-button v-if="signImg ? true : false" type="primary" size="mini" @click="signNameClick">选择已有签名</el-button>
            <el-button type="primary" size="mini" @click="newSignNameClick">使用新的签名</el-button>
        </div>
        <div v-if="isShowSignImg">
            <img :src="currentSelectSignImg" style="width: 260px;height: 66px;object-fit: contain;">
        </div>
        <!-- <div v-if="isShowNewSignImg">
            <esign ref="signName" :showCreateBtn="true" @esignHandle="esignHandle"></esign>
        </div> -->
        <esignCode ref="esign" @getImgUrl="esignHandle" />
    </div>
</template>
  
<script>
import { mapState } from "vuex";

// import esign from '@/components/esign';
import esignCode from '@/components/esignCode';

export default {
    name: "esignHandle",
    // esign
    components: { esignCode },
    props: {
        // 选择的签名(已有的 或者 新生成的)
        selectSignImg: {
            type: String,
            default: ''
        },
        // 是否显示当前签名(反显)
        isShowCurrSignImg: {
            type: Boolean,
            default: false,
        },
    },
    data(){
        return {
            isShowSignImg: false,  //显示签名
            // isShowNewSignImg: false,  //显示签名画板
        }
    },
    watch: {
        selectSignImg: {
            immediate: true,
            handler(newV) {
                if(newV && this.isShowCurrSignImg){
                    this.isShowSignImg = true;
                }
            }
        },
    },
    computed: {
        ...mapState("permission", [
            'signImg'
        ]),
        currentSelectSignImg: {
            get() {
                return this.selectSignImg;
            },
            set(val) {
                this.$emit('update:selectSignImg', val)
            }
        },
    },
    created(){
        
    },
    methods: {
        // 签名处理 获取 手写签名 图片地址
        esignHandle(v){
            this.$store.dispatch('permission/signImgActions', v);
            // this.isShowNewSignImg = false;
            this.isShowSignImg = true;
            this.currentSelectSignImg = v;
            this.$emit('selectSignImgAfter', v);
        },
        // 点击 使用新的签名
        newSignNameClick(){
            this.isShowSignImg = false;
            // this.isShowNewSignImg = true;
            this.$refs['esign'].isShowOpen();
            this.$emit('selectSignImgAfter', this.signImg);
        },
        // 点击 选择已有签名
        signNameClick(){
            // this.isShowNewSignImg = false;
            this.isShowSignImg = true;
            this.currentSelectSignImg = this.signImg;
            this.$emit('selectSignImgAfter', this.signImg);
        },
        // 签名 清空画板
        // signReset(){
        //     if(this.isShowNewSignImg){
        //         this.$refs['signName'].handleReset();  //清空
        //     }
        // },
        // 组件 清空
        handleReset(){
            this.isShowSignImg = false;
            // this.isShowNewSignImg = false;
            // this.signReset();
        },
    },
};
</script>
  
<style lang="scss" scoped>
.esignHandle{
    
}
</style>
  